import { Layout, Modal } from "antd";
import { Content } from "antd/es/layout/layout";
import dayjs from "dayjs";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useDispatch } from "react-redux";
import { Rnd } from "react-rnd";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";

import WORK_SPACE from "@assets/images/WORK_SPACE.png";
import { ReactComponent as ICON_ARROW_BACK_MENU } from "@assets/svgs/ICON_ARROW_BACK_MENU.svg";
import { ReactComponent as ICON_IMPORT_ADS_BLOCK } from "@assets/svgs/ICON_IMPORT_ADS_BLOCK.svg";
import { ReactComponent as ICON_IMPORT_DATE } from "@assets/svgs/ICON_IMPORT_DATE.svg";
import { ReactComponent as ICON_IMPORT_PREVIEW } from "@assets/svgs/ICON_IMPORT_PREVIEW.svg";
import { ReactComponent as ICON_IMPORT_STATIC_IMAGE } from "@assets/svgs/ICON_IMPORT_STATIC_IMAGE.svg";
import { ReactComponent as ICON_IMPORT_TIME } from "@assets/svgs/ICON_IMPORT_TIME.svg";
import { ReactComponent as ICON_IMPORT_WEATHER } from "@assets/svgs/ICON_IMPORT_WEATHER.svg";
import { Button } from "@components/Button";
import Header from "@components/Header";
import { Icon } from "@components/Icon";
import { InnerContents } from "@components/InnerContents";
import { SideMenu } from "@components/SideMenu";
import { Text } from "@components/Text";
import { useSocketContext } from "@contexts/socket/socketContext";
import { ManageBlock } from "@pages/CampaignBlocksPageV2/ManageBlock";
import { setCampaignPreview } from "@redux/reducers/campaignPreview.reducers";
import {
  COLOR_DARK,
  COLOR_GREEN,
  COLOR_RED,
  COLOR_WHITE,
} from "@static/COLORS";
import { CONTENT_STYLES } from "@static/CONTENT_STYLES";
import { KEY_CAMPAIGNS_ADD } from "@static/PERMISSION_KEY";
import { MENU_SIZE } from "@static/SIZE";
import { getAuthUserPermissions } from "@utils/getAuthUserPermissions";
import { fetchAPI } from "@utils/https/fetchAPI";

import { DraggableBlock } from "./DraggableBlock";
import { DraggableBlockWidget } from "./DraggableBlockWidget";
import { ManageWidgetImage } from "./ManageWidgetImage";
import { RenderInnerMediaBlock } from "./RenderInnerMediaBlock";
import { RenderInnerWidget } from "./RenderInnerWidget";
const { REACT_APP_WITH_KIOS } = process.env;

const SectionMainAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  border-radius: 6px;
  box-sizing: border-box;
`;

const SectionEditor = styled.div`
  display: flex;
  gap: 16px;
  /* height: 100%; */
  height: calc(100% - 54px);
`;

const SectionWorkspace = styled.div`
  width: 75%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

// const WorkspaceLayout = styled.div`
//   position: relative;
//   background-image: url(${WORK_SPACE});
//   background-repeat: no-repeat;
//   background-attachment: fixed;
//   background-size: cover;
//   width: 100%;
//   overflow: hidden;
//   height: ${({ height }) => `${window.innerHeight - height}px`};
// `;

const ContainerWorkspace = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${({ height }) => `${window.innerHeight - height}px`};
  border: 1px solid #e0e2ea;
`;

const ContainerWorkspaceLayout = styled.div`
  width: ${({ isVertical = false }) => (isVertical ? "50%" : "100%")};
  height: 100%;
`;

const WorkspaceLayout = styled.div`
  position: relative;
  background-image: url(${WORK_SPACE});
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  width: 100%;
  overflow: hidden;
  height: 100%;
`;

const SectionAction = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 15%;
  border-radius: 16px;
  background: #0000000d;
  padding: 1.2%;
  box-sizing: border-box;
`;

const SectionSelectType = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  overflow-x: scroll;
`;

const Line = styled.div`
  height: 100%;
  width: 1px;
  background: rgba(43, 47, 50, 0.2);
  margin-left: 1.2%;
  margin-right: 1.2%;
`;

const SectionImportList = styled.div`
  width: 25%;
  height: 100%;
  display: flex;
  gap: 12px;
  flex-direction: column;
  justify-content: space-between;
`;

const SectionImport = styled.div`
  height: 100%;
  border-radius: 16px;
  background: #0000000d;
  overflow: scroll;
`;

const SectionSubmit = styled.div`
  width: 100%;
`;

const ImportButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  aspect-ratio: 1/1;
  gap: 5%;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 20%;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  pointer-events: ${({ disabled }) => (disabled ? "not-allow" : "auto")};
`;

const PreviewButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  aspect-ratio: 1/1;
  gap: 5%;
  background: linear-gradient(270deg, #0eb8b8 0%, #1cdbab 100%);
  border-radius: 20%;
  cursor: pointer;
`;

const BlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1%;
  padding: 3%;
  width: 100%;
  height: 100%;
  overflow-x: scroll;
`;

const SectionWorkspaceBlockName = styled.div`
  position: absolute;
  top: 5px;
  left: 5px;
  background: ${COLOR_WHITE};
  padding: 2px 15px;
  border-radius: 20px;
  border: 1px solid ${COLOR_DARK};
`;

const IMPORT_COMPONENT_TYPE_LIST = [
  {
    label: "Media",
    icon: ICON_IMPORT_ADS_BLOCK,
    type: "ADS_BLOCKS",
    isDisabled: false,
    isWidget: false,
  },
  {
    label: "Image",
    icon: ICON_IMPORT_STATIC_IMAGE,
    type: "STATIC_IMAGE",
    isDisabled: false,
    isWidget: true,
    defaultWidth: 300,
    defaultHeight: 300,
    is_use_media_in_project: true,
    mediaId: null,
    attribute: { path: null },
  },
  {
    label: "Time",
    icon: ICON_IMPORT_TIME,
    type: "STATIC_TIME",
    isDisabled: false,
    isWidget: true,
    defaultWidth: 300,
    defaultHeight: 300,
    attribute: { format: 12, clockType: "ANALOG" },
  },
  {
    label: "Date",
    icon: ICON_IMPORT_DATE,
    type: "STATIC_DATE",
    isDisabled: false,
    isWidget: true,
    defaultWidth: 300,
    defaultHeight: 300,
    attribute: null,
  },
  {
    label: "Weather",
    icon: ICON_IMPORT_WEATHER,
    type: "STATIC_WEATHER",
    isDisabled: false,
    isWidget: true,
    defaultWidth: 300,
    defaultHeight: 300,
    attribute: null,
  },
];

const SectionSelectGroup = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  overflow: hidden;
`;

const GROUP_TYPE_LIST = [
  { label: "Media", value: "media-group" },
  { label: "Widget", value: "widget-group" },
];

export default () => {
  const socket = useSocketContext();
  const workspaceLayoutRef = useRef(null);
  const sectionActionRef = useRef(null);
  const sectionMainActionRef = useRef(null);

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const permission = getAuthUserPermissions();
  const defaultAdsBlocks = _.get(location, ["state", "adsBlocks"]);
  const defaultWidgets = _.get(location, ["state", "widgets"], []);

  const locationState = _.get(location, ["state"]);

  console.log("locationState :>> ", locationState);

  const selectedCampaign = _.chain(locationState)
    .omit(["adsBlocks", "widgets"])
    .value();

  const [isModalVisible, setIsModalVisible] = useState({
    isOpen: false,
    modalType: null,
  });

  const [selectedWidgetImageIndex, setSelectedWidgetImageIndex] =
    useState(null);

  const [selectedBlock, setSelectedBlock] = useState(null);
  const [sectionActionHeight, setSectionActionHeight] = useState(0);

  const [defaultCampaign, setDefaultCampaign] = useState(selectedCampaign);
  const [adsBlocks, setAdsBlocks] = useState(defaultAdsBlocks);
  const [widgets, setWidgets] = useState(defaultWidgets);

  // const [defaultCampaign, setDefaultCampaign] = useState({});
  // const [adsBlocks, setAdsBlocks] = useState([]);
  // const [widgets, setWidgets] = useState([]);

  const [workspaceSize, setWorkspaceSize] = useState({ width: 0, height: 0 });
  const campaign_name = _.get(defaultCampaign, ["campaign_name"]);
  const campaignHeight = _.get(defaultCampaign, ["campaign_height"]);
  const campaignWidth = _.get(defaultCampaign, ["campaign_width"]);

  const [selectedGroup, setSelectedGroup] = useState(GROUP_TYPE_LIST[0]?.value);

  useEffect(() => {
    console.log("campaign_id :>> ", _.get(location, ["state", "campaign_id"]));
  }, []);

  useEffect(() => {
    if (workspaceLayoutRef.current) {
      const { clientWidth, clientHeight } = workspaceLayoutRef.current;
      setWorkspaceSize({ width: clientWidth, height: clientHeight });
    }

    if (sectionActionRef.current) {
      const actionHeight = sectionActionRef.current.clientHeight;
      setSectionActionHeight(actionHeight);
    }
  }, []);

  const scaleX = _.get(workspaceSize, ["width"]) / campaignWidth;
  const scaleY = _.get(workspaceSize, ["height"]) / campaignHeight;

  const handleDragStop = ({ index, e, d }) => {
    setSelectedGroup("media-group");
    const scaledX = Math.round(d.x / scaleX);
    const scaledY = Math.round(d.y / scaleY);
    setAdsBlocks((prev) => {
      const updateAdsBlocks = _.map(prev, (blockItem, blockIndex) =>
        blockIndex === index
          ? { ...blockItem, position_x: scaledX, position_y: scaledY }
          : blockItem
      );
      return updateAdsBlocks;
    });
  };

  const handleResizeStop = ({ index, e, direction, ref, delta, position }) => {
    const newWidth = Math.round(parseFloat(ref.style.width) / scaleX);
    const newHeight = Math.round(parseFloat(ref.style.height) / scaleY);
    const scaledX = Math.round(position.x / scaleX);
    const scaledY = Math.round(position.y / scaleY);
    setAdsBlocks((prev) => {
      const updateAdsBlocks = _.map(prev, (blockItem, blockIndex) =>
        blockIndex === index
          ? {
              ...blockItem,
              width: newWidth,
              height: newHeight,
              position_x: scaledX,
              position_y: scaledY,
            }
          : blockItem
      );
      return updateAdsBlocks;
    });
  };

  const onHandleAddBlock = () => {
    setSelectedGroup("media-group");
    const unix = dayjs().unix().toString();
    const width = _.get(locationState, ["campaign_width"]) / 3;
    const height = _.get(locationState, ["campaign_height"]) / 3;
    const positionX = _.random(0, campaignWidth - width);
    const positionY = _.random(0, campaignHeight - height);
    const updateBlock = {
      id: uuidv4(),
      block_key: uuidv4(),
      advertising_campaign_id: _.get(locationState, ["campaign_id"]),
      name: `ID-${unix}`,
      width,
      height,
      position_x: positionX,
      position_y: positionY,
      blockMedias: [],
    };
    setAdsBlocks((prev) => [{ ...updateBlock }, ...prev]);
  };

  // ===========================================================
  // widget
  const onHandleAddWidget = ({ item }) => {
    const type = _.get(item, ["type"]);
    const isDuplicateType = _.chain(widgets)
      .cloneDeep()
      .find((widgetItem, widgetIndex) => {
        return _.get(widgetItem, ["type"]) === type;
      })
      .value();
    if (isDuplicateType) {
      console.log("duplicate :>> ");
      return;
    }
    // time props rectangle มาด้วย
    setSelectedGroup("widget-group");
    const unix = dayjs().unix().toString();
    const width = _.get(item, ["defaultWidth"]);
    const height = _.get(item, ["defaultHeight"]);
    const positionX = _.random(0, campaignWidth - width);
    const positionY = _.random(0, campaignHeight - height);
    const updateWidget = {
      id: uuidv4(),
      widget_key: uuidv4(),
      type: _.get(item, ["type"]),
      advertising_campaign_id: _.get(locationState, ["campaign_id"]),
      name: `WIDGET-${unix}`,
      width,
      height,
      position_x: positionX,
      position_y: positionY,
      attribute: _.get(item, ["attribute"], null),
    };
    setWidgets((prev) => [...prev, { ...updateWidget }]);
  };

  const handleDragStopWidget = ({ index, e, d }) => {
    setSelectedGroup("widget-group");
    const scaledX = Math.round(d.x / scaleX);
    const scaledY = Math.round(d.y / scaleY);
    setWidgets((prev) => {
      const updateAdsBlocks = _.map(prev, (blockItem, blockIndex) =>
        blockIndex === index
          ? { ...blockItem, position_x: scaledX, position_y: scaledY }
          : blockItem
      );
      return updateAdsBlocks;
    });
  };

  const handleResizeStopWidget = ({
    index,
    e,
    direction,
    ref,
    delta,
    position,
  }) => {
    const newWidth = Math.round(parseFloat(ref.style.width) / scaleX);
    const newHeight = Math.round(parseFloat(ref.style.height) / scaleY);
    const scaledX = Math.round(position.x / scaleX);
    const scaledY = Math.round(position.y / scaleY);
    setWidgets((prev) => {
      const updateAdsBlocks = _.map(prev, (blockItem, blockIndex) =>
        blockIndex === index
          ? {
              ...blockItem,
              width: newWidth,
              height: newHeight,
              position_x: scaledX,
              position_y: scaledY,
            }
          : blockItem
      );
      return updateAdsBlocks;
    });
  };

  const moveBlockWidget = (fromIndex, toIndex) => {
    setWidgets((prevBlocks) => {
      const updatedList = [...prevBlocks];
      const [movedItem] = updatedList.splice(fromIndex, 1);
      updatedList.splice(toIndex, 0, movedItem);
      return updatedList;
    });
  };

  const onHandleDeleteWidget = (index) => {
    const updatedWidget = _.filter(widgets, (filterItem, filterIndex) => {
      return filterIndex !== index;
    });
    setWidgets(updatedWidget);
  };

  const onHandleUpdateWidgetInputValue = ({ index, name, value }) => {
    const updatedWidgets = _.chain(widgets)
      .cloneDeep()
      .set([index, name], value)
      .value();
    setWidgets(updatedWidgets);
  };

  const onHandleUpdateWidgetImage = ({ index, updateData }) => {
    // console.log("index :>> ", index);
    // console.log("updateData :>> ", updateData);

    const updatedWidgets = _.chain(widgets)
      .cloneDeep()
      .map((widgetItem, widgetIndex) => {
        return index === widgetIndex
          ? { ...widgetItem, ...updateData }
          : widgetItem;
      })
      .value();
    console.log("updatedWidgets :>> ", updatedWidgets);
    setWidgets(updatedWidgets);
  };

  const onHandleOpenSelectImage = ({ index }) => {
    console.log("object :>> ", { index });
    setSelectedWidgetImageIndex(index);
    setIsModalVisible({ isOpen: true, modalType: "manage-widget" });
  };

  // widget
  // ===========================================================

  const moveBlock = (fromIndex, toIndex) => {
    setAdsBlocks((prevBlocks) => {
      const updatedList = [...prevBlocks];
      const [movedItem] = updatedList.splice(fromIndex, 1);
      updatedList.splice(toIndex, 0, movedItem);
      return updatedList;
    });
  };

  const onHandleDeleteBlock = (index) => {
    const updatedBlocks = _.filter(adsBlocks, (filterItem, filterIndex) => {
      return filterIndex !== index;
    });
    setAdsBlocks(updatedBlocks);
  };

  const onHandleUpdateBlockInputValue = ({ index, name, value }) => {
    const updatedBlocks = _.chain(adsBlocks)
      .cloneDeep()
      .set([index, name], value)
      .value();
    setAdsBlocks(updatedBlocks);
  };

  const onHandleFullFrameBlock = ({ index }) => {
    const updatedBlocks = _.chain(adsBlocks)
      .cloneDeep()
      .merge({
        [index]: {
          width: campaignWidth,
          height: campaignHeight,
          position_x: 0,
          position_y: 0,
        },
      })
      .value();
    setAdsBlocks(updatedBlocks);
  };

  const onHandleOpenModal = ({ item }) => {
    setSelectedBlock(item);
    setIsModalVisible({ isOpen: true, modalType: "manage-block" });
  };

  const onHandleSubmit = async () => {
    console.log("widgets :>> ", widgets);
    console.log("adsBlocks :>> ", adsBlocks);
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/advertising-campaigns-update-ads-blocks-and-block-medias",
      isAuth: true,
      data: {
        advertising_campaign_id: _.get(defaultCampaign, ["campaign_id"]),
        adsBlocks,
        widgets,
      },
    });
    if (_.get(resp, ["status"])) {
      // const results = _.chain(resp).get(["result"]).value();
      // navigate(-1);
      toast.success("Save Campaign Blocks Success.");
      Swal.fire({
        title: "จะส่ง Content ขึ้นระบบเลยไหม?",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: COLOR_GREEN,
        cancelButtonColor: COLOR_RED,
        confirmButtonText: "ok",
        cancelButtonText: "cancel",
        reverseButtons: true,
        customClass: {
          title: "custom-font-swal2",
          content: "custom-font-swal2",
          confirmButton: "custom-font-swal2",
          cancelButton: "custom-font-swal2",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          const sendForce = await fetchAPI({
            method: "post",
            path: "/api/v1/send-force-sync-by-ads-campaign-id",
            isAuth: true,
            data: {
              advertising_campaign_id: _.get(defaultCampaign, ["campaign_id"]),
            },
          });
          if (REACT_APP_WITH_KIOS === "true") {
            socket.emit(
              "BACK-OFFICE-SEND-KIOS-VIEW-UPDATE-CONTENT-WITH-CAMPAIGN-ID",
              {
                campaignId: _.get(defaultCampaign, ["campaign_id"]),
              }
            );
          }

          if (_.get(sendForce, ["status"])) {
            navigate(-1);
          }
        } else {
          navigate(-1);
        }
      });
    }
  };

  // ส่วนนี้ ต้อง เอามา order ให้เหมือนเดิมด้วย

  const onHandleCampaignPreview = () => {
    const previewData = {
      id: _.get(defaultCampaign, ["campaign_id"]),
      name: _.get(defaultCampaign, ["campaign_name"]),
      start_date: _.get(defaultCampaign, ["campaign_start_date"]),
      end_date: _.get(defaultCampaign, ["campaign_end_date"]),
      start_time: "00:00:00",
      end_time: "23:59:59",
      width: _.get(defaultCampaign, ["campaign_width"]),
      height: _.get(defaultCampaign, ["campaign_height"]),
      adsBlocks: _.cloneDeep(adsBlocks),
      widgets: _.cloneDeep(widgets),
    };
    dispatch(setCampaignPreview(previewData));
    window.open("/campaign-preview", "_blank");
  };

  const isVertical = _.toInteger(campaignWidth) < _.toInteger(campaignHeight);

  return (
    <Layout hasSider>
      <SideMenu />
      <Layout style={{ marginLeft: MENU_SIZE }}>
        <Header />
        <Content style={CONTENT_STYLES}>
          <InnerContents>
            <SectionMainAction ref={sectionMainActionRef}>
              <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                <Button onClick={() => navigate(-1)} padding="0px">
                  <Icon
                    isCursor
                    width={14}
                    height={14}
                    style={{ marginRight: 8 }}
                  >
                    <ICON_ARROW_BACK_MENU />
                  </Icon>
                  <Text fontSize="18px" fontWeight="600">
                    Back
                  </Text>
                </Button>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "8px",
                }}
              >
                <Text fontSize="18px" fontWeight="600">
                  Campaign: {campaign_name}
                </Text>
                <Text fontSize="18px" fontWeight="600">
                  |
                </Text>
                <Text fontSize="18px" fontWeight="600">
                  W: {campaignWidth} , H: {campaignHeight}
                </Text>
              </div>
            </SectionMainAction>
            <SectionEditor>
              <SectionWorkspace>
                <ContainerWorkspace height={sectionActionHeight}>
                  <ContainerWorkspaceLayout isVertical={isVertical}>
                    <WorkspaceLayout ref={workspaceLayoutRef}>
                      {_.map(widgets, (item, index) => {
                        const dimensionsX = _.chain(item)
                          .get(["position_x"])
                          .toInteger()
                          .value();
                        const dimensionsY = _.chain(item)
                          .get(["position_y"])
                          .toInteger()
                          .value();

                        const dimensionsWidth = _.chain(item)
                          .get(["width"])
                          .toInteger()
                          .value();

                        const dimensionsHeight = _.chain(item)
                          .get(["height"])
                          .toInteger()
                          .value();

                        const type = _.get(item, ["type"]);
                        return (
                          <Rnd
                            key={index}
                            default={{
                              x: 0,
                              y: 0,
                              width: campaignWidth * scaleX,
                              height: campaignWidth * scaleY,
                            }}
                            size={{
                              width: dimensionsWidth * scaleX,
                              height: dimensionsHeight * scaleY,
                            }}
                            position={{
                              x: dimensionsX * scaleX,
                              y: dimensionsY * scaleY,
                            }}
                            minWidth={50 * scaleX}
                            minHeight={50 * scaleX}
                            bounds="parent"
                            onDragStop={(e, d) =>
                              handleDragStopWidget({ index, e, d })
                            }
                            onResizeStop={(
                              e,
                              direction,
                              ref,
                              delta,
                              position
                            ) =>
                              handleResizeStopWidget({
                                index,
                                e,
                                direction,
                                ref,
                                delta,
                                position,
                              })
                            }
                            style={{
                              backgroundColor: "transparent",
                              zIndex: 1000 - index,
                            }}
                          >
                            <RenderInnerWidget index={index} item={item} />
                          </Rnd>
                        );
                      })}

                      {_.map(adsBlocks, (item, index) => {
                        const dimensionsX = _.chain(item)
                          .get(["position_x"])
                          .toInteger()
                          .value();
                        const dimensionsY = _.chain(item)
                          .get(["position_y"])
                          .toInteger()
                          .value();

                        const dimensionsWidth = _.chain(item)
                          .get(["width"])
                          .toInteger()
                          .value();

                        const dimensionsHeight = _.chain(item)
                          .get(["height"])
                          .toInteger()
                          .value();

                        const firstMediaInBlocks = _.chain(item)
                          .get(["blockMedias"])
                          .first()
                          .value();

                        return (
                          <Rnd
                            key={index}
                            default={{
                              x: 0,
                              y: 0,
                              width: campaignWidth * scaleX,
                              height: campaignHeight * scaleY,
                            }}
                            size={{
                              width: dimensionsWidth * scaleX,
                              height: dimensionsHeight * scaleY,
                            }}
                            position={{
                              x: dimensionsX * scaleX,
                              y: dimensionsY * scaleY,
                            }}
                            minWidth={50 * scaleX}
                            minHeight={50 * scaleY}
                            bounds="parent"
                            onDragStop={(e, d) =>
                              handleDragStop({ index, e, d })
                            }
                            onResizeStop={(
                              e,
                              direction,
                              ref,
                              delta,
                              position
                            ) =>
                              handleResizeStop({
                                index,
                                e,
                                direction,
                                ref,
                                delta,
                                position,
                              })
                            }
                            style={{
                              backgroundColor: "rgba(0, 0, 0, 0.50)",
                              zIndex: 900 - index,
                            }}
                          >
                            <SectionWorkspaceBlockName>
                              <Text
                                fontSize={isVertical ? "10px" : "14px"}
                                fontWeight="500"
                              >
                                {_.get(item, ["name"])}
                              </Text>
                            </SectionWorkspaceBlockName>
                            <RenderInnerMediaBlock
                              index={index}
                              width={dimensionsWidth * scaleX}
                              height={dimensionsHeight * scaleY}
                              firstMediaInBlocks={firstMediaInBlocks}
                            />
                          </Rnd>
                        );
                      })}
                    </WorkspaceLayout>
                  </ContainerWorkspaceLayout>
                </ContainerWorkspace>

                <SectionAction ref={sectionActionRef}>
                  <SectionSelectType>
                    {_.map(IMPORT_COMPONENT_TYPE_LIST, (item, index) => {
                      const RenderIcon = _.get(item, ["icon"]);
                      const isDisabled = _.get(item, ["isDisabled"], false);
                      const isWidget = _.get(item, ["isWidget"], false);
                      const type = _.get(item, ["type"]);

                      const usedWidgets = _.chain(widgets)
                        .cloneDeep()
                        .map((widget) => {
                          return _.get(widget, ["type"]);
                        })
                        .value();

                      return (
                        <ImportButton
                          key={index}
                          disabled={
                            isWidget
                              ? _.includes(usedWidgets, type)
                              : isDisabled
                          }
                          onClick={() => {
                            isWidget
                              ? onHandleAddWidget({ item })
                              : onHandleAddBlock();
                          }}
                        >
                          <Icon width={"30%"} height={"30%"} isCursor>
                            <RenderIcon fill="#5E6366" />
                          </Icon>
                          <Text style={{ fontSize: "95%" }} color="#5E6366">
                            {_.get(item, ["label"])}
                          </Text>
                        </ImportButton>
                      );
                    })}
                  </SectionSelectType>
                  <Line></Line>
                  <PreviewButton onClick={() => onHandleCampaignPreview()}>
                    <Icon width={"30%"} height={"30%"} isCursor>
                      <ICON_IMPORT_PREVIEW />
                    </Icon>
                    <Text style={{ fontSize: "95%" }} color={COLOR_WHITE}>
                      Preview
                    </Text>
                  </PreviewButton>
                </SectionAction>
              </SectionWorkspace>
              <SectionImportList>
                <SectionSelectGroup>
                  {_.map(GROUP_TYPE_LIST, (item, index) => {
                    const isActive = selectedGroup === item?.value;
                    return (
                      <Button
                        style={{ flex: 1 }}
                        key={index}
                        onClick={() => setSelectedGroup(item?.value)}
                        padding="0px"
                        height={"100%"}
                        color={isActive ? COLOR_GREEN : "#09090905"}
                        border={"0px"}
                      >
                        <Text
                          fontSize="14px"
                          fontWeight="500"
                          color={isActive ? COLOR_WHITE : COLOR_DARK}
                        >
                          {item?.label}
                        </Text>
                      </Button>
                    );
                  })}
                </SectionSelectGroup>
                <SectionImport>
                  <DndProvider backend={HTML5Backend}>
                    {selectedGroup === GROUP_TYPE_LIST[0]?.value && (
                      <BlockContainer>
                        {_.map(adsBlocks, (item, index) => {
                          return (
                            <DraggableBlock
                              key={index}
                              index={index}
                              item={item}
                              moveBlock={moveBlock}
                              campaignWidth={campaignWidth}
                              campaignHeight={campaignHeight}
                              onHandleOpenModal={onHandleOpenModal}
                              onHandleUpdateBlockInputValue={
                                onHandleUpdateBlockInputValue
                              }
                              onHandleDeleteBlock={onHandleDeleteBlock}
                              onHandleFullFrameBlock={onHandleFullFrameBlock}
                            />
                          );
                        })}
                      </BlockContainer>
                    )}
                    {selectedGroup === GROUP_TYPE_LIST[1]?.value && (
                      <BlockContainer>
                        {_.map(widgets, (item, index) => {
                          return (
                            <DraggableBlockWidget
                              key={index}
                              index={index}
                              item={item}
                              moveBlock={moveBlockWidget}
                              campaignWidth={campaignWidth}
                              campaignHeight={campaignHeight}
                              onHandleOpenSelectImage={onHandleOpenSelectImage}
                              // onHandleOpenModal={onHandleOpenModal}
                              onHandleUpdateWidgetInputValue={
                                onHandleUpdateWidgetInputValue
                              }
                              onHandleDeleteWidget={onHandleDeleteWidget}
                            />
                          );
                        })}
                      </BlockContainer>
                    )}
                  </DndProvider>
                </SectionImport>

                <SectionSubmit>
                  {_.includes(permission, KEY_CAMPAIGNS_ADD) && (
                    <Button
                      onClick={() => onHandleSubmit()}
                      style={{ width: "100%" }}
                      color={COLOR_GREEN}
                      fontColor={COLOR_WHITE}
                      padding="7px 15px"
                    >
                      Save
                    </Button>
                  )}
                </SectionSubmit>
              </SectionImportList>
            </SectionEditor>
          </InnerContents>
        </Content>
      </Layout>
      <Modal
        style={{ zIndex: 3000 }}
        width={"80%"}
        destroyOnClose={true}
        title={`${_.chain(selectedBlock)
          .get(["name"])
          .toUpper()
          .thru((block) => {
            const isBlock =
              _.get(isModalVisible, ["modalType"]) === "manage-block";
            return isBlock ? `Block ${block}` : `Widget Image`;
          })
          .value()}`}
        open={_.get(isModalVisible, ["isOpen"])}
        footer={null}
        onCancel={() =>
          setIsModalVisible((prev) => ({ ...prev, isOpen: false }))
        }
      >
        {_.get(isModalVisible, ["modalType"]) === "manage-block" && (
          <ManageBlock
            adsBlocks={adsBlocks}
            setIsModalVisible={setIsModalVisible}
            setAdsBlocks={setAdsBlocks}
            campaignData={selectedCampaign}
            selectedBlock={selectedBlock}
            blockMedias={_.get(selectedBlock, ["blockMedias"])}
          />
        )}

        {_.get(isModalVisible, ["modalType"]) === "manage-widget" && (
          <ManageWidgetImage
            setIsModalVisible={setIsModalVisible}
            widgetIndex={selectedWidgetImageIndex}
            onHandleUpdateWidgetImage={onHandleUpdateWidgetImage}
          />
        )}
      </Modal>
    </Layout>
  );
};
